var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content", attrs: { id: "dashboardPage" } },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _vm.send_store
              ? _c("div", { staticClass: "card-body" }, [
                  _c(
                    "form",
                    {
                      attrs: { action: "" },
                      on: { submit: _vm.requestCalculation },
                    },
                    [
                      _c("div", { staticClass: "flex" }, [
                        _c("div", [
                          _c("label", [_vm._v("Склад отправитель")]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.send_store,
                                  expression: "send_store",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "send_store" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.send_store = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(
                              _vm.send_store_list,
                              function (store, index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: store.id } },
                                  [_vm._v(_vm._s(store.name))]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("label", [_vm._v("Склад получатель")]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.receive_store,
                                  expression: "receive_store",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "receive_store" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.receive_store = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(
                              _vm.receive_store_list,
                              function (store, index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: store.id } },
                                  [_vm._v(_vm._s(store.name))]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              position: "relative",
                              "min-width": "200px",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info",
                                staticStyle: {
                                  position: "absolute",
                                  bottom: "0",
                                },
                                attrs: { type: "submit" },
                                on: { click: _vm.getStorageRequest },
                              },
                              [_vm._v("Показать запас")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              position: "relative",
                              "min-width": "200px",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info",
                                staticStyle: {
                                  position: "absolute",
                                  bottom: "0",
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.getAllPreStore },
                              },
                              [_vm._v("Просчитать запас")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              position: "relative",
                              "min-width": "200px",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info",
                                staticStyle: {
                                  position: "absolute",
                                  bottom: "0",
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.getClearedFigures },
                              },
                              [_vm._v("Автосписок")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("pulse-loader", {
        staticStyle: { "text-align": "center" },
        attrs: { loading: _vm.loading, color: _vm.color },
      }),
      _vm._v(" "),
      _vm.storage_calculation
        ? _c("div", [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(_vm.storage_calculation.prep_names),
                      function (prep, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.storage_calculation.in_send_store[prep.id]
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            _vm._l(
                              _vm.storage_calculation.reserved_qnty[prep.id],
                              function (qnty, storeId, index2) {
                                return _c("div", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.storage_calculation.stores_names[
                                          storeId
                                        ]
                                      ) +
                                      " => " +
                                      _vm._s(qnty) +
                                      "\n                "
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.storage_calculation.updated_send_store[
                                    prep.id
                                  ]
                                ) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.storage_calculation.in_receive_store[
                                  prep.id
                                ]
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.storage_calculation.storage_request[prep.id]
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.getRoundedQuantity(
                                  _vm.storage_calculation.storage_request[
                                    prep.id
                                  ]
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.storage_calculation.in_receive_store[
                                  prep.id
                                ] -
                                  _vm.getRoundedQuantity(
                                    _vm.storage_calculation.storage_request[
                                      prep.id
                                    ]
                                  )
                              )
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.request
        ? _c("div", [
            _c("h4", [_vm._v("Общая картинка")]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(_vm.request.prep_names),
                      function (prep, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.request.in_send_store[prep.id]) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.request.in_receive_store[prep.id]) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.request.requested_preps[prep.id]
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.request.requested_preps[prep.id].total
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            _vm._l(
                              _vm.request.dother_stores,
                              function (storeId, index) {
                                return _c("div", { key: index }, [
                                  _vm.request.store[storeId][prep.id]
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.request.store_names[storeId]
                                          ) +
                                            " => " +
                                            _vm._s(
                                              _vm.request.store[storeId][
                                                prep.id
                                              ] * -1
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  (_vm.request.in_receive_store[prep.id]
                                    ? _vm.request.in_receive_store[prep.id]
                                    : 0) -
                                    _vm.getRequestedQuantity(
                                      _vm.request,
                                      prep.id
                                    )
                                ) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td"),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("h4", [_vm._v("Закрывает отправитель")]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(_vm.request.sender_prep_names.close),
                      function (prep, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.request.sender_order.close[prep.id])
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("h4", [_vm._v("Не закрывает отправитель")]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.request.sender_prep_names.no_close
                      ),
                      function (prep, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.request.sender_order.no_close[prep.id])
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("pulse-loader", {
        staticStyle: { "text-align": "center" },
        attrs: { loading: _vm.loading_long, color: _vm.color },
      }),
      _vm._v(" "),
      _vm.reserve_total
        ? _c("div", [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", [_vm._v("Брони")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(_vm.reserve_total.prep_names),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.reserve_total.request[prep.id])),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.reserve_total.send_store[prep.id])
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v("Закрываем бронь")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.reserve_total.prep_names,
                        _vm.reserve_total.reserve_request_closing.close
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.reserve_total.reserve_request_closing.close[
                                  prep.id
                                ]
                              )
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v("НЕ закрываем бронь")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.reserve_total.prep_names,
                        _vm.reserve_total.reserve_request_closing.no
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.reserve_total.reserve_request_closing.no[
                                  prep.id
                                ]
                              )
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", [_vm._v("Запас")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(_vm.reserve_total.store_preps_name),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.getRoundedQuantity(
                                  _vm.reserve_total.requested_store_quantities[
                                    prep.id
                                  ]
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.reserve_total.store_preps_for_store[prep.id]
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.reserve_total.store_preps_for_supply[
                                  prep.id
                                ]
                              )
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v("Закрываем запас")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.reserve_total.closing_names,
                        _vm.reserve_total.store_request_closing.close
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.reserve_total.store_request_closing.close[
                                  prep.id
                                ]
                              )
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v("НЕ закрываем запас")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(10),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.reserve_total.closing_names,
                        _vm.reserve_total.store_request_closing.no
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.reserve_total.store_request_closing.no[
                                  prep.id
                                ]
                              )
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.store_request
        ? _c(
            "div",
            _vm._l(_vm.store_request.stores_names, function (name, id, index) {
              return _c("div", { key: index }, [
                _vm.store_request.requested_quantities[id]
                  ? _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            on: {
                              click: function ($event) {
                                _vm.store_request.requested_quantities[
                                  id
                                ].isShow =
                                  !_vm.store_request.requested_quantities[id]
                                    .isShow
                              },
                            },
                          },
                          [_vm._v(_vm._s(name))]
                        ),
                        _vm._v(" id:" + _vm._s(id) + "\n          "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.store_request.requested_quantities[id]
                                    .isShow,
                                expression:
                                  "store_request.requested_quantities[id].isShow",
                              },
                            ],
                          },
                          [
                            _c("table", { staticClass: "table table-hover" }, [
                              _vm._m(11, true),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                { attrs: { id: ["storage_" + id] } },
                                _vm._l(
                                  _vm.orderedPrepNames(
                                    _vm.store_request.prep_names,
                                    _vm.store_request.requested_quantities[id]
                                  ),
                                  function (prep, index) {
                                    return _vm.store_request
                                      .requested_quantities[id][prep.id]
                                      ? _c("tr", { key: index }, [
                                          _c("td", [_vm._v(_vm._s(index + 1))]),
                                          _vm._v(" "),
                                          _c("td", [_vm._v(_vm._s(prep.id))]),
                                          _vm._v(" "),
                                          _c("td", [_vm._v(_vm._s(prep.name))]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.store_request
                                                  .requested_quantities[id][
                                                  prep.id
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.store_request
                                                  .actual_storage[id][prep.id]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm.store_request.preps_in_reserve[
                                              id
                                            ][prep.id] &&
                                            _vm.store_request.preps_in_reserve[
                                              id
                                            ][prep.id][id]
                                              ? _c(
                                                  "div",
                                                  _vm._l(
                                                    _vm.store_request
                                                      .preps_in_reserve[id][
                                                      prep.id
                                                    ][id].orders,
                                                    function (qnty, orderId) {
                                                      return _c("div", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(orderId) +
                                                            " => " +
                                                            _vm._s(qnty) +
                                                            "\n                      "
                                                        ),
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm.store_request.preps_in_reserve[
                                              id
                                            ][prep.id] &&
                                            _vm.store_request.preps_in_reserve[
                                              id
                                            ][prep.id][id]
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.store_request
                                                          .actual_storage[id][
                                                          prep.id
                                                        ] -
                                                          _vm.store_request
                                                            .preps_in_reserve[
                                                            id
                                                          ][prep.id].total
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.store_request
                                                        .actual_storage[id][
                                                        prep.id
                                                      ]
                                                    )
                                                  ),
                                                ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.getRoundedQuantity(
                                                    _vm.store_request
                                                      .requested_quantities[id][
                                                      prep.id
                                                    ]
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.getDifference(
                                                    _vm.store_request
                                                      .requested_quantities[id][
                                                      prep.id
                                                    ],
                                                    _vm.store_request
                                                      .actual_storage[id][
                                                      prep.id
                                                    ],
                                                    _vm.store_request
                                                      .preps_in_reserve[id][
                                                      prep.id
                                                    ]
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]),
                                        ])
                                      : _vm._e()
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "tabs",
        { staticClass: "tabs-default hidden" },
        [
          _c("tab", { attrs: { name: "Общая бронь" } }, [
            _vm.all_data
              ? _c(
                  "div",
                  { staticStyle: { padding: "0 20px" } },
                  _vm._l(_vm.tab_1_data, function (data, index) {
                    return _c("div", { key: index, staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            on: {
                              click: function ($event) {
                                data.isShow = !data.isShow
                              },
                            },
                          },
                          [_vm._v(_vm._s(data.store.name))]
                        ),
                        _vm._v(
                          " id:" + _vm._s(data.store.id) + "\n            "
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: data.isShow,
                                expression: "data.isShow",
                              },
                            ],
                          },
                          [
                            _c("table", { staticClass: "table table-hover" }, [
                              _c("thead", [
                                _c("th", { staticClass: "wd-40" }),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-200" }),
                                _vm._v(" "),
                                _c("th", [_vm._v("Препарат")]),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-100" }, [
                                  _vm._v("Бронь"),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-200" }, [
                                  _vm._v("Заявки"),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-200" }, [
                                  _vm._v("Склад по факту"),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-200" }, [
                                  _vm._v("Транзит"),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-200" }, [
                                  _vm._v("Склад - транзит"),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-200" }, [
                                  _vm._v("Склад - Бронь"),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-100" }, [
                                  _vm._v("Новая бронь"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.orderedPrepNames(data.prep_names),
                                  function (prep, index) {
                                    return _c("tr", { key: index }, [
                                      _c("td", [_vm._v(_vm._s(index + 1))]),
                                      _c("td", [_vm._v(_vm._s(prep.id))]),
                                      _c("td", [_vm._v(_vm._s(prep.name))]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            data.requested_preps[prep.id].ttl
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        _vm._l(
                                          data.requested_preps[prep.id].orders,
                                          function (qnty, order, index2) {
                                            return _c("span", { key: index2 }, [
                                              index2 != 0 ? _c("br") : _vm._e(),
                                              _vm._v(
                                                _vm._s(order) +
                                                  " => " +
                                                  _vm._s(qnty)
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        _vm._l(
                                          data.actual_store[prep.id],
                                          function (qnty, store, index3) {
                                            return _c("span", { key: index3 }, [
                                              index3 != 0 ? _c("br") : _vm._e(),
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    data.store_names[store]
                                                  ) +
                                                  " => " +
                                                  _vm._s(qnty) +
                                                  "\n                      "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        data.preps_in_transit.in[prep.id]
                                          ? _c(
                                              "div",
                                              [
                                                _c("span", [
                                                  _vm._v("Поступление"),
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  data.preps_in_transit.in[
                                                    prep.id
                                                  ],
                                                  function (preps, storeId) {
                                                    return _c(
                                                      "div",
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              data.store_names[
                                                                storeId
                                                              ]
                                                            ) + " => "
                                                          ),
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                preps.total
                                                              )
                                                            ),
                                                          ]),
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          preps,
                                                          function (
                                                            invoices,
                                                            index5
                                                          ) {
                                                            return _c("span", [
                                                              _c("br"),
                                                              index5 != "total"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        invoices.invoice
                                                                      ) +
                                                                        " => " +
                                                                        _vm._s(
                                                                          invoices.qnty
                                                                        )
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        data.preps_in_transit.out[prep.id]
                                          ? _c(
                                              "div",
                                              [
                                                _c("span", [
                                                  _vm._v("Перемещение"),
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  data.preps_in_transit.out[
                                                    prep.id
                                                  ],
                                                  function (preps, storeId) {
                                                    return _c(
                                                      "div",
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              data.store_names[
                                                                storeId
                                                              ]
                                                            ) + " => "
                                                          ),
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                preps.total
                                                              )
                                                            ),
                                                          ]),
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          preps,
                                                          function (
                                                            invoices,
                                                            index5
                                                          ) {
                                                            return _c("span", [
                                                              _c("br"),
                                                              index5 != "total"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        invoices.invoice
                                                                      ) +
                                                                        " => " +
                                                                        _vm._s(
                                                                          invoices.qnty
                                                                        )
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        _vm._l(
                                          data.actual_store_wtransit[prep.id],
                                          function (qnty, storeId, index6) {
                                            return _c("span", { key: index6 }, [
                                              index6 != 0 ? _c("br") : _vm._e(),
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    data.store_names[storeId]
                                                  ) +
                                                  " => " +
                                                  _vm._s(qnty) +
                                                  "\n                      "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        _vm._l(
                                          data.updated_store[prep.id],
                                          function (qnty, store, index4) {
                                            return _c("span", { key: index4 }, [
                                              index4 != 0 ? _c("br") : _vm._e(),
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    data.store_names[store]
                                                  ) +
                                                  " => " +
                                                  _vm._s(qnty) +
                                                  "\n                      "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            data.updated_request[prep.id].ttl
                                          )
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("tab", { attrs: { name: "Запросы" } }, [
            _vm.all_data
              ? _c(
                  "div",
                  { staticStyle: { padding: "0 20px" } },
                  _vm._l(_vm.tab_1_data, function (data, index) {
                    return _c("div", { key: index, staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            on: {
                              click: function ($event) {
                                data.isShow = !data.isShow
                              },
                            },
                          },
                          [_vm._v(_vm._s(data.store.name))]
                        ),
                        _vm._v(
                          " id:" + _vm._s(data.store.id) + "\n            "
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: data.isShow,
                                expression: "data.isShow",
                              },
                            ],
                          },
                          [
                            _c("table", { staticClass: "table table-hover" }, [
                              _c("thead", [
                                _c("th", { staticClass: "wd-40" }),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-200" }),
                                _vm._v(" "),
                                _c("th", [_vm._v("Препарат")]),
                                _vm._v(" "),
                                _c("th", { staticClass: "wd-100" }, [
                                  _vm._v("Бронь"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.orderedPrepNamesWithRequest(
                                    data.prep_names,
                                    data.updated_request
                                  ),
                                  function (prep, index) {
                                    return _c("tr", { key: index }, [
                                      _c("td", [_vm._v(_vm._s(index + 1))]),
                                      _c("td", [_vm._v(_vm._s(prep.id))]),
                                      _c("td", [_vm._v(_vm._s(prep.name))]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            data.updated_request[prep.id].ttl
                                          )
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("tab", { attrs: { name: "tab3" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { position: "relative", "min-width": "200px" } },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-info",
            staticStyle: { position: "absolute", bottom: "0" },
            attrs: { type: "submit" },
          },
          [_vm._v("Показать бронь")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix" }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Наличие на отправителе")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }, [_vm._v("Брони на дочерних")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [
        _vm._v("Обновл. наличие на отправителе"),
      ]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Наличие на получателе")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Запрос получателя")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Окр")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Чистый запрос")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Наличие на отправителе")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Наличие на получателе")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Запрос получателя")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }, [_vm._v("Запрос дочерних")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Остаток получателя")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Остаток отправителя")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Для закрытия брони")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("На отправителе")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Запрос на запас")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("На получателе")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("На Отправителе")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Необходимо")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Наличии")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Бронь")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Остаток")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Окр")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Запрос")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }